import { useTheme, changeColorOpacity, COLOR_VISION_SINGLE_ITEM } from '@shopify/polaris-viz-core';
import { useState } from 'react';
import { TOOLTIP_BG_OPACITY } from '../../../../constants.js';
import { useBrowserCheck } from '../../../../hooks/useBrowserCheck.js';
import styles from './TooltipContentContainer.scss.js';
import { jsx } from 'react/jsx-runtime';
import { useWatchColorVisionEvents } from '../../../../hooks/ColorVisionA11y/useWatchColorVisionEvents.js';

function TooltipContentContainer({
  children,
  maxWidth,
  theme
}) {
  const {
    isFirefox
  } = useBrowserCheck();
  const selectedTheme = useTheme(theme);
  const [activeColorVisionIndex, setActiveIndex] = useState(-1);
  useWatchColorVisionEvents({
    type: COLOR_VISION_SINGLE_ITEM,
    onIndexChange: ({
      detail
    }) => setActiveIndex(detail.index)
  });
  return /*#__PURE__*/jsx("div", {
    className: styles.Container,
    style: {
      background: changeColorOpacity(selectedTheme.tooltip.backgroundColor, isFirefox ? 1 : TOOLTIP_BG_OPACITY),
      maxWidth
    },
    children: children({
      activeColorVisionIndex
    })
  });
}

export { TooltipContentContainer };
